<template>
    <el-table :data="tableData" stripe style="width: 100%" :cell-style="{'text-align':'center'}">
        <el-table-column prop="openNum" label="期号" align="center">
        </el-table-column>
        <el-table-column prop="result" label="号码" align="center">
            <template slot-scope="scope">
                {{ getResult(scope.row.result) }}
            </template>
        </el-table-column>
        <el-table-column prop="num" label="预测" align="center">
            <template slot-scope="scope">
                {{ getGuessValue(scope.row.guess3) }}
            </template>
        </el-table-column>
        <el-table-column prop="num" label="结果" align="center">
            <template slot-scope="scope">
                <template v-if="getResult(scope.row.result) =='未开奖'">
                    <span >等待开奖</span>
                </template>
                <template v-else-if="getGuessResult(scope.row) ==1">
                    <span style="color:  red;">成功</span>
                </template>
                <template v-else>
                    <span>未中奖</span>
                </template>
            </template>
        </el-table-column>
    </el-table>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    props: {
        tableData: {
            type: Array,
            default: null,
            require: true
        }
    },
    methods: {
        getResult(data) {
            if (data && data.length == 3) {
                return data[0] + "+" + data[1] + "+" + data[2] + "=" + (Number(data[0]) + Number(data[1]) + Number(data[2]))
            }
            return "未开奖"
        },
        getGuessValue(data) {
            let guessData = ""
            switch (data) {
                case 0: {
                    guessData += "大"
                    break
                }
                case 1:
                    {
                        guessData += "小"
                        break
                    }
            }
            
            return guessData

        },
        getGuessResult(data) {
            let winCount = 0
            if(data.guess3 ==0 && this.isBigNum(data)){
                winCount++
            }else if(data.guess3 ==1 && !this.isBigNum(data))
            {
                winCount++
            }
            
            return winCount
        },
        isBigNum(data) {

            if (data.sumResult >= 14) return true
            return false
        },
        isOddNumber(data) {
            if (data.sumResult == 0 || (data.sumResult % 2 == 0)) return false

            return true
        },
        isVerySmall(data) {
            if (data.sumResult <= 5) return true
            return false
        },
        isVersyBig(data) {
            if (data.sumResult >= 23) return true
            return false
        },
    }
}
</script>